import { CarouselItem } from 'element-ui'

const YCarouselItem = CarouselItem
YCarouselItem.$depends = [CarouselItem]
YCarouselItem.$name = 'y-carousel-item'
YCarouselItem._name = 'CarouselItem 走马灯选项'

export default YCarouselItem
